import { render, staticRenderFns } from "./ReplenishmentSend.vue?vue&type=template&id=2ed12049&scoped=true&"
import script from "./ReplenishmentSend.vue?vue&type=script&lang=js&"
export * from "./ReplenishmentSend.vue?vue&type=script&lang=js&"
import style0 from "./ReplenishmentSend.vue?vue&type=style&index=0&id=2ed12049&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed12049",
  null
  
)

export default component.exports